import { render, staticRenderFns } from "./CarrinhosHeader.vue?vue&type=template&id=5e2e5c48"
import script from "./CarrinhosHeader.vue?vue&type=script&lang=js"
export * from "./CarrinhosHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports